<template>
  <div
    style="
      background: linear-gradient(45deg, #28a745, #20c997);
      padding: 20px 0;
    "
  >
    <layouts-header />

    <!-- breadcrumb-bar-->
    <div class="breadcrumb-bar bg-transparent">
      <div class="container">
        <div class="row align-items-center text-center col-md-12 col-12">
          <h2 class="breadcrumb-title text-white">بيع سيارتك</h2>
        </div>
      </div>
    </div>
    <!-- / breadcrumb-bar -->
  </div>

  <div class="container mx-auto p-4 bg-white shadow rounded-lg">
    <!-- Add Car Form -->
    <div class="mt-4">
      <!-- <div class="search-bar mb-3">
        <input
          type="text"
          class="form-control search-input"
          placeholder="ابحث عن سيارة..."
        />
        <i class="fa fa-search search-icon"></i>
      </div> -->
      <div class="mb-4" id="filters">
        <div class="row">
          <!-- Upload Images -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">ارفع الصور</label>
            <div class="border rounded p-3 color-green">
              <input
                required
                type="file"
                multiple
                name="photos"
                id="photos"
                @change="uploadPhotos"
                class="form-control"
              />
              <p class="text-sm mt-2">
                - حمل صورة واحدة على الأقل<br />
                - ما تقدر ترفع أكثر من 30 صورة<br />
                - خلى صورك حلوة عشان نشجع الزبون
              </p>
              <br />
            </div>
          </div>

          <!-- Upload Reels -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">ريلز اسرعلك</label>
            <div class="border rounded p-3 color-green">
              <input
                type="file"
                accept="video/*"
                name="video"
                id="video"
                @change="uploadVideo"
                class="form-control"
              />
              <p class="text-sm mt-2">
                - بتقدر ترفع ريلز مدته 60 ثانية أو أقل<br />
                - لما تشترك بخدمة الريلز بتبيع اسرع وبتصير مشاهداتك أعلى<br />
                - صور الريلز تبعك بكاميرا حلوة<br />
                - إذا حابب تكون معنا بخدمة الريلز ارفع الفيديو وخلال 24 ساعة
                منتواصل معك
              </p>
            </div>
          </div>
        </div>

        <!-- One choice filters -->
        <div class="row">
          <div
            v-for="filter in oneChoice"
            :key="filter.id"
            class="col-12 col-md-4 mb-3"
          >
            <select class="form-select" v-model="filter.result">
              <!-- @change="handleSelect(filter)" -->
              <option disabled value="">{{ filter.title }}</option>
              <option
                v-for="(option, i) in filter.options"
                v-if="
                  filter.id !== 2 &&
                  filter.id !== 3 &&
                  filter.id !== 4 &&
                  filter.id !== 5
                "
                :key="filter.id"
                :value="option"
              >
                {{ option }}
              </option>

              <option
                v-for="city in cities"
                v-else-if="filter.id === 2"
                :key="city.id"
                :value="city.id"
              >
                {{ city.name }}
              </option>

              <option
                v-for="district in districts"
                v-else-if="filter.id === 3"
                :key="district.id"
                :value="district.id"
              >
                {{ district.name }}
              </option>

              <option
                v-for="brand in brands"
                v-else-if="filter.id === 4"
                :key="brand.id"
                :value="brand"
              >
                {{ brand.name }}
              </option>

              <option
                v-for="model in brandModels"
                v-else-if="filter.id === 5"
                :key="model.id"
                :value="model"
              >
                {{ model.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Multiple choice filters -->
        <div class="row">
          <div
            v-for="filter in multipleChoice"
            :key="filter.id"
            class="col-12 col-md-4 mb-3"
          >
            <label class="form-label">{{ filter.title }}</label>
            <div
              class="border rounded p-2 max-h-40 overflow-y-auto color-green"
            >
              <div
                v-for="(option, i) in filter.options"
                :key="i"
                class="form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :id="filter.id + '-' + i"
                  :value="option"
                  v-model="filter.result"
                />
                <label class="form-check-label" :for="filter.id + '-' + i">
                  {{ option }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- سجل العداد -->
          <div class="col-12 col-md-6 mb-3">
            <input
              type="number"
              class="form-control"
              v-model="meterReading"
              :disabled="isZero"
              placeholder="سجل العداد بالزبط"
            />
          </div>

          <!-- إذا صفر -->
          <div class="col-12 col-md-6 mb-3 d-flex align-items-center">
            <input
              type="checkbox"
              id="zeroCheck"
              v-model="isZero"
              class="form-check-input me-2"
              @change="handleZeroCheck"
            />
            <label for="zeroCheck" class="form-check-label">زيرو</label>
          </div>
        </div>

        <!-- Payment Method -->
        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <select
              class="form-select"
              :disabled="
                oneChoice[0].result == 'تقسيط' || oneChoice[0].result == 'ايجار'
              "
              v-model="paymentType"
            >
              <option disabled value="">اختر طريقة الدفع</option>
              <option value="كاش">كاش</option>
              <option value="تقسيط">تقسيط</option>
            </select>
          </div>

          <!-- قابل للتفاوض -->
          <div class="col-12 col-md-6 mb-3 d-flex align-items-center">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="negotiableSwitch"
                v-model="isNegotiable"
              />
              <label class="form-check-label" for="negotiableSwitch">
                قابل للتفاوض {{ buyType }}
              </label>
            </div>
          </div>
        </div>

        <!-- If "ايجار" -->
        <div class="row" v-if="buyType === 'ايجار'">
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">سعر الايجار اليومى</label>
            <input
              type="number"
              class="form-control"
              v-model="rentPriceDaily"
              placeholder="ادخل سعر الايجار اليومى"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">سعر الايجار الاسبوعى</label>
            <input
              type="number"
              class="form-control"
              v-model="rentPriceWeekly"
              placeholder="ادخل سعر الايجار الاسبوعى"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">سعر الايجار الشهرى</label>
            <input
              type="number"
              class="form-control"
              v-model="rentPriceMonthly"
              placeholder="ادخل سعر الايجار الشهرى"
            />
          </div>
        </div>

        <!-- If "كاش" -->
        <div class="row" v-else-if="buyType === 'كاش' || paymentType === 'كاش'">
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">السعر</label>
            <input
              type="number"
              class="form-control"
              v-model="salePrice"
              placeholder="ادخل السعر"
            />
          </div>
        </div>

        <!-- If "تقسيط" -->
        <div
          class="row"
          v-else-if="buyType === 'تقسيط' || paymentType === 'تقسيط'"
        >
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">السعر المطلوب</label>
            <input
              type="number"
              class="form-control"
              v-model="installmentPrice"
              placeholder="ادخل السعر المطلوب"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">القسط</label>
            <input
              type="number"
              class="form-control"
              v-model="installmentValue"
              placeholder="ادخل قيمة القسط"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="form-label">مدة القسط (بالأشهر)</label>
            <input
              type="number"
              class="form-control"
              v-model="installmentDuration"
              placeholder="ادخل مدة القسط"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <input
              type="text"
              class="form-control"
              v-model="title"
              placeholder="عنوان الاعلان"
            />
          </div>

          <div class="col-12 col-md-4 mb-3">
            <input
              type="text"
              class="form-control"
              v-model="mobile1"
              placeholder="رقم الهاتف"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <input
              type="text"
              class="form-control"
              v-model="mobile2"
              placeholder="رقم الهاتف للواتساب"
            />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <textarea
              class="form-control"
              v-model="description"
              placeholder="تفاصيل الاعلان"
              rows="6"
            >
            </textarea>
          </div>
        </div>

        <div v-if="errors.length" class="alert alert-danger mt-3">
          <ul>
            <li v-for="(err, i) in errors" :key="i">{{ err }}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Preview Button -->
    <b-button
      class="primary btn-block mb-4"
      type="submit"
      @click="submitForm"
      :disabled="isLoading"
    >
      {{ isLoading ? "جارى التحميل" : "انشر إعلانك" }}
      <i v-if="isLoading" class="fas fa-spinner fa-spin me-2"></i>
    </b-button>
  </div>

  <!-- /Article section  -->
  <layout-footer></layout-footer>
</template>

<script>
import { useBrandStore } from "@/stores/brand";
import { useCarStore } from "@/stores/car";
import { useLocationStore } from "@/stores/location";
export default {
  data() {
    return {
      text: "الصفحات",
      text1: "الاخبار ",

      oneChoice: [
        {
          id: 1,
          title: "الحالة",
          options: [
            "جديد",
            "مستورد",
            "مستعمل",
            "جديد مستورد",
            "ايجار",
            "تقسيط",
          ],
          result: "",
        },
        {
          id: 2,
          title: "المحافظة",
          options: [],
          result: "",
        },
        {
          id: 3,
          title: "المنطقة",
          options: [],
          result: "",
        },
        {
          id: 4,
          title: "نوع السيارة",
          options: [],
          result: "",
        },
        {
          id: 5,
          title: "موديل السيارة",
          options: ["others"],
          result: "",
        },
        {
          id: 6,
          title: "سنة الصنع",
          options: [
            "1980",
            "1981",
            "1982",
            "1983",
            "1984",
            "1985",
            "1986",
            "1987",
            "1988",
            "1989",
            "1990",
            "1991",
            "1992",
            "1993",
            "1994",
            "1995",
            "1996",
            "1997",
            "1998",
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025",
          ],
          result: "",
        },
        {
          id: 7,
          title: "بلد التصنيع",
          options: ["اوروبا", "امريكا", "الوكالة", "الخليج", "غير ذلك"],
          result: "",
        },
        {
          id: 8,
          title: "الوقود",
          options: ["بنزين", "ديزل", "كهرباء", "هايبرد"],
          result: "",
        },
        {
          id: 9,
          title: "الجير",
          options: ["اوتو", "عادى", "تيبترونيك"],
          result: "",
        },
        {
          id: 10,
          title: "المحرك",
          options: [
            "0-499 سي سي",
            "500-999 سي سي",
            "1000-1999 سي سي",
            "2000-2999 سي سي",
            "3000-3999 سي سي",
            "4000-4999 سي سي",
            "5000-5999 سي سي",
            "6000+ سي سي",
          ],
          result: "",
        },
        {
          id: 11,
          title: "لون السيارة",
          options: [
            "أبيض",
            "أسود",
            "اسمنتى",
            "ازرق فاتح",
            "أزرق",
            "اخضر",
            "برتقالي",
            "بني",
            "بنفسجي",
            "تركواز",
            "بيج",
            "خمري",
            "ذهبي",
            "رمادي",
            "زيتى",
            "فضى",
            "كحلي",
          ],
          result: "",
        },
        {
          id: 12,
          title: "لون الفرش",
          options: [
            "أبيض",
            "أسود",
            "اسمنتى",
            "ازرق فاتح",
            "أزرق",
            "اخضر",
            "برتقالي",
            "بني",
            "بنفسجي",
            "تركواز",
            "بيج",
            "خمري",
            "ذهبي",
            "رمادي",
            "زيتى",
            "فضى",
            "كحلي",
          ],
          result: "",
        },
        {
          id: 13,
          title: "فئة السيارة",
          options: ["سيدان", "SUV", "هاتشباك", "دفع رباعي", "كوبيه", "فان"],
          result: "",
        },
        {
          id: 14,
          title: "قديش ماشية",
          options: [
            "0-10,000 كم",
            "10,000-20,000 كم",
            "20,000-30,000 كم",
            "30,000-40,000 كم",
            "40,000-50,000 كم",
            "50,000-60,000 كم",
            "60,000-70,000 كم",
            "70,000-80,000 كم",
            "80,000-90,000 كم",
            "90,000-100,000 كم",
            "+100,000 كم",
          ],
          result: "",
        },
        {
          id: 15,
          title: "الدهان",
          options: [
            "اعيد دهانها كليا",
            "اعيد دهانها جزئيا",
            "الدهان اصلي",
            "اخرى",
          ],
          result: "",
        },
        {
          id: 16,
          title: "حالة الشاسيه",
          options: [
            "تعرض لحادث (اضرار جسيمة فى البودى)",
            " حادث بسيط (يحتاج البودى لاصلاح)",
            "جيد (عيوب بسيطة فى البودى)",
            "ممتاز بدون حوادث",
            "اخرى",
          ],
          result: "",
        },
      ],

      multipleChoice: [
        {
          id: 1,
          title: "المواصفات",
          options: [
            "مدخل Aux/USB",
            "أكياس هوائية",
            "تحكم كهربائى بالمقاعد",
            "تحكم بالمقود",
            "مقاعد بذاكرة",
            "زجاج كهربائى",
            "سنترلوك",
            "مقاعد مدفأة",
            "مشغل وسطيات",
            "مقاعد جلد",
            "مقاعد رياضية",
            "مقاعد مبردة",
            "مقعد كهربائى خلفى",
            "مقود مدفأ",
            "مكيف",
            "نظام انذار",
            "اخرى",
          ],
          result: [],
        },
        {
          id: 2,
          title: "المواصفات الخارجية",
          options: [
            "أنوار نهارية",
            "اطار احتياطى",
            "جنوط",
            "حساسات امامية",
            "حساسات خلفية",
            "فتح بدون مفتاح",
            "فتحة سقف",
            "بانوراما",
            "مرايا قابلة للطى كهربائيا",
            "مصابيح زينون",
            "مصابيح LED",
            "نسخة رياضية",
            "كهرباء خلفى",
            "اخرى",
          ],
          result: [],
        },
        {
          id: 3,
          title: "التقنيات الحديثة",
          options: [
            "Apple CarPlay",
            "Android Auto",
            "اوامر صوتية",
            "بروجيكتور",
            "بلوتوث",
            "تشغيل عن بعد",
            "تنبيه من التصادم الأمامى",
            "تنبيه النقاط العمياء",
            "تنبيه مغادرة المسار",
            "حساسات ضغط الاطارات",
            "دفلوك",
            "رادار",
            "شاشة لمس",
            "شاشة وسائط",
            "إغلاق تلقائي للأبواب",
            "كاميرا 360 درجة",
            "كاميرا خلفية",
            "نظام تعليق رياضى",
            "نظام ملاحة / خرائط",
            "مانع الانزلاق",
            "مثبت سرعة",
            "مساعد الاصطفاف",
            "نظام ABS",
            "اخرى",
          ],
          result: [],
        },
      ],

      usageStatus: {
        جديد: "new",
        مستورد: "imported",
        مستعمل: "used",
        "جديد مستورد": "imported_new",
        ايجار: "rent",
        تقسيط: "installment",
      },

      title: "",
      mobile1: "",
      mobile2: "",
      description: "",
      meterReading: "",
      isZero: false,
      paymentType: "",
      buyType: "",

      salePrice: "",

      installmentPrice: "",
      installmentValue: "",
      installmentDuration: "",

      rentPriceDaily: "",
      rentPriceWeekly: "",
      rentPriceMonthly: "",

      photos: null,
      video: null,
      isNegotiable: false,

      errors: [],

      cities: [],
      districts: [],

      brands: [],
      brandModels: [],

      useLocation: null,
      useCar: null,
      useBrand: null,
      isLoading: false,
    };
  },
  async mounted() {
    this.useLocation = useLocationStore();
    this.useCar = useCarStore();
    this.useBrand = useBrandStore();
    this.useLocation.getAllCities().then(() => {
      this.cities = this.useLocation.allCities;
    });
    this.useBrand.getAllBrands().then(() => {
      this.brands = this.useBrand.allBrands;
    });
  },
  computed: {
    selectedBrand() {
      return this.oneChoice[3]?.result;
    },
    selectedCity() {
      return this.oneChoice[1]?.result;
    },
    selectedType() {
      return this.oneChoice[0]?.result;
    },
  },
  watch: {
    selectedBrand(newVal) {
      this.useBrand.getBrandModels(newVal.id).then(() => {
        this.brandModels = this.useBrand.brandModels;
      });
    },
    selectedCity(newVal) {
      this.useLocation.getCityDistricts(newVal).then(() => {
        this.districts = this.useLocation.cityDistricts;
      });
    },
    selectedType(newVal) {
      if (newVal === "ايجار") {
        this.paymentType = "كاش";
        this.buyType = "ايجار";
        this.isPaymentFixed = true;
      } else if (newVal === "تقسيط") {
        this.paymentType = "تقسيط";
        this.buyType = "تقسيط";
      } else {
        this.paymentType = "";
        this.buyType = newVal;
      }
    },
  },
  methods: {
    handleZeroCheck() {
      if (this.isZero) {
        this.meterReading = 0;
      } else {
        this.meterReading = null;
      }
    },
    uploadPhotos(e) {
      this.photos = Array.from(e.target.files);
    },
    uploadVideo(e) {
      this.video = Array.from(e.target.files);
    },
    // handleSelect(filter) {
    //   if (filter.id === 4) {
    //     const brand = filter.result;
    //     let modelFilter = this.oneChoice.find((f) => f.id === 5);
    //     modelFilter.options = this.carModels[brand] || ["others"];
    //     modelFilter.result = "";
    //   }
    // },
    async submitForm() {
      this.errors = [];

      if (this.photos == null) {
        this.errors.push("لازم ترفع صورة واحدة على الأقل.");
      }

      this.oneChoice.forEach((f) => {
        if (!f.result && f.id !== 3) {
          this.errors.push(`يرجى اختيار ${f.title}.`);
        }
      });

      this.multipleChoice.forEach((item) => {
        if (!item.result || item.result.length === 0) {
          this.errors.push(`يرجى اختيار واحد على الاقل من ${item.title}.`);
        }
      });

      if (!this.isZero && !this.meterReading) {
        this.errors.push("سجل العداد مطلوب أو اختر أنه صفر.");
      }

      // ✅ طريقة الدفع
      if (!this.paymentType) {
        this.errors.push("يرجى اختيار طريقة الدفع.");
      } else if (this.buyType === "كاش" && !this.salePrice) {
        this.errors.push("يرجى إدخال سعر الكاش.");
      } else if (this.buyType === "تقسيط") {
        if (
          !this.installmentPrice ||
          !this.installmentValue ||
          !this.installmentDuration
        ) {
          this.errors.push("يرجى إدخال تفاصيل التقسيط كاملة.");
        }
      }

      // ✅ باقي الحقول
      if (!this.title) this.errors.push("عنوان الإعلان مطلوب.");
      if (!this.mobile1) this.errors.push("رقم الهاتف مطلوب.");
      if (!this.description) this.errors.push("تفاصيل الإعلان مطلوبة.");

      if (this.errors.length != 0) {
        return;
      }

      const object = {
        title: this.title,
        description: this.description,
        // model_variant
        manufacturing_region: this.oneChoice[6].result,
        gear: this.oneChoice[8].result,
        fuel_type: this.oneChoice[7].result,
        engine_capacity: this.oneChoice[9].result,
        color: this.oneChoice[10].result,
        upholstery_color: this.oneChoice[11].result,
        year: this.oneChoice[5].result,
        type: this.oneChoice[12].result,
        mileage: this.oneChoice[13].result,
        paint_condition: this.oneChoice[14].result,
        vehicle_body: this.oneChoice[15].result,
        payment_method: this.paymentType == "كاش" ? "cash" : "installment",
        negotiable: this.isNegotiable == true ? 1 : 0,
        usage_status: this.usageStatus[this.oneChoice[0].result],
        brand_id: this.oneChoice[3].result.id,
        model_id: this.oneChoice[4].result.id,
        city_id: this.oneChoice[1].result,
        district_id: this.oneChoice[2].result,
        images: this.photos,
        real: this.video,
        specifications: this.multipleChoice[0].result,
        external_specifications: this.multipleChoice[1].result,
        technical_specifications: this.multipleChoice[2].result,
        // price
        rent_or_sale:
          this.oneChoice[0].result == "ايجار"
            ? "rent"
            : this.paymentType == "تقسيط"
            ? "installment"
            : "sale",
        kilometers: this.meterReading,
        phone: this.mobile1,
        whatsapp: this.mobile2,
        brand_name: {
          ar: this.oneChoice[3].result.name,
        },
        model_name: {
          ar: this.oneChoice[4].result.name,
        },
      };
      if (this.buyType == "ايجار") {
        object.rent_price_daily = this.rentPriceDaily;
        object.rent_price_weekly = this.rentPriceWeekly;
        object.rent_price_monthly = this.rentPriceMonthly;

        delete object.installment_price;
        delete object.installment_duration_months;
        delete object.installment_monthly;

        delete object.sale_price;
      } else if (this.buyType == "تقسيط") {
        object.installment_price = this.installmentPrice;
        object.installment_duration_months = this.installmentDuration;
        object.installment_monthly = this.installmentValue;

        delete object.rent_price_daily;
        delete object.rent_price_weekly;
        delete object.rent_price_monthly;

        delete object.sale_price;
      } else {
        object.sale_price = this.salePrice;

        delete object.rent_price_daily;
        delete object.rent_price_weekly;
        delete object.rent_price_monthly;

        delete object.installment_price;
        delete object.installment_duration_months;
        delete object.installment_monthly;
      }

      let formData = new FormData();

      for (let key in object) {
        if (
          key !== "brand_name" &&
          key !== "model_name" &&
          key !== "images" &&
          key !== "real"
        ) {
          if (Array.isArray(object[key])) {
            object[key].forEach((val) => {
              formData.append(`${key}[]`, val);
            });
          } else {
            formData.append(key, object[key]);
          }
        }
      }

      // handle nested translations
      formData.append("brand_name[ar]", object.brand_name.ar);
      formData.append("model_name[ar]", object.model_name.ar);

      // append images
      this.photos.forEach((file, index) => {
        formData.append(`images[${index}]`, file);
      });

      // append video if exists
      if (this.video) {
        formData.append("real", this.video[0]);
      }

      this.isLoading = true;
      const id = await this.useCar.addCar(formData);
      this.isLoading = false;
      if (id == null) {
        return;
      }
      this.$router.push("/listing/" + id);
    },
  },
};
</script>
<style scoped>
.gradient-title {
  background: linear-gradient(to right, #0e3b2f, #2fa66b);
  /* -webkit-background-clip: text; */
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.section-search {
  background-color: white;
  padding: 60px 0;
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 90%;
  transform: translateX(-50%);
  width: 80%;
  box-shadow: 0 35px 80px rgba(0, 128, 0, 0.25); /* أخضر فاتح */
  border-radius: 20px;
}

.filter-title {
  color: #00a35c; /* أخضر غامق */
  font-weight: bold;
  font-size: 1.5rem;
}

.search-bar {
  position: relative;
  width: 100%;
}
.search-input {
  border-radius: 8px;
  padding-right: 40px;
  background: #eafaf2; /* أخضر فاتح جدًا */
  border: 1px solid #00c569;
  height: 50px;
}
.search-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  color: #00c569;
}

.availability {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #00a35c;
  font-weight: 600;
}

/* Switch style */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #a3e3cb;
  transition: 0.4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #00c569;
}
input:checked + .slider:before {
  transform: translateX(22px);
}
input,
select,
textarea,
.color-green {
  border: 1px solid #00c569 !important;
  background-color: #eafaf2;
}

.accordion-item {
  background-color: #eafaf2;
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid #00c569;
}
.accordion-button {
  background-color: #eafaf2;
  color: #00a35c;
  font-weight: bold;
  box-shadow: none;
}
.accordion-button::after {
  transform: rotate(180deg);
  filter: hue-rotate(90deg);
  margin: 0;
}
.accordion-button.collapsed::after {
  transform: rotate(0deg);
}

.btn-advanced {
  background: linear-gradient(135deg, #fd7e14, #ff8c42) !important;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  border: none;
}
.btn-search {
  background-color: #00c569;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  border: none;
}

@media (max-width: 600px) {
  .section-search {
    width: 90%;
  }
}
</style>
